import Artist from './pages/Artist'
import Artwork from './pages/Artwork'
import Home from './pages/Home'
import Search from './pages/Search'
import NoFound from './pages/NoFound'
import { usePageViews } from './hooks/UsePageViews';
import { Switch, Route, Redirect } from 'react-router-dom';
import Collections from './pages/Collections'
import Artworks from './pages/Artworks'
import Collection from './pages/Collection'

/**
 * Set the application routes and trigger a new "page view" event.
 *
 * @return {*} 
 */
export default function App() {

    usePageViews();

    return (
        <Switch>
            <Route path='/' component={Home} exact />
            <Redirect from='/collection/' to='/' exact />
            <Route path='/search/:search_string' component={Search} exact />
            <Redirect from='/search/:search_string/' to='/search/:search_string' />
            <Redirect from='/collection/search/:search_string/' to='/search/:search_string/' />
            <Redirect from='/search/' to='/' exact />
            <Route path='/artists/:artist/artworks/:artwork' component={Artwork} exact />
            <Redirect from='/artists/:artist/artworks/:artwork/' to='/artists/:artist/artworks/:artwork' />
            <Redirect from='/collection/artists/:artist/artworks/:artwork' to='/artists/:artist/artworks/:artwork' />
            <Route path='/artists/:artist' component={Artist} exact />
            <Redirect from='/artists/:artist/artworks/' to='/artists/:artist' exact />
            <Redirect from='/collection/artists/:artist/artworks/' to='/artists/:artist' exact />
            <Redirect from='/artists/' to='/' exact />
            <Route path='/art/collection' component={Collections} exact />
            <Route path='/art/artworks' component={Artworks} exact />
            <Route path='/collections/:collection' component={Collection} exact />
            <Route path='*' component={NoFound} />
        </Switch>
    );
};
